import React, { useMemo } from 'react';
import _ from 'lodash';

import PhotoComponent from '@components/photo-component';

import style from '../workorder.module.scss';

const ViewableImages = ({ field }) => {
  const { fieldImagesList, regularImageList } = useMemo(() => {
    const fieldImagesList = field?.value?.photos?.filter((x) => !x?.imageUrl) || [];
    const regularImageList = field?.value?.photos?.filter((x) => x?.imageUrl) || [];
    return { fieldImagesList, regularImageList };
  }, [field?.value?.photos]);

  return (
    <div className={style.body}>
      {_.size(field?.value?.photos) > 0 && (
        <>
          <h6>Photos </h6>

          <div className={style.grid2ds} style={{ marginTop: '0px' }}>
            {fieldImagesList?.map((card) => (
              <PhotoComponent
                key={card?.photoId}
                photoId={card?.photoId}
                image={null}
                imageUrl={card?.imageUrl}
                categoryValue={card?.categoryValue || 'Uncategorized'}
                captionValue={card?.captionValue}
                editable={false}
                imageName={card?.imageName}
                viewableImages
              />
            ))}
          </div>

          <div className={style.grid2} style={{ marginTop: '0px' }}>
            {regularImageList?.map((card) => (
              <PhotoComponent
                key={card?.photoId}
                photoId={card?.photoId}
                image={null}
                imageUrl={card?.imageUrl}
                categoryValue={card?.categoryValue || 'Uncategorized'}
                captionValue={card?.captionValue}
                editable={false}
                imageName={card?.imageName}
                viewableImages
              />
            ))}
          </div>
        </>
      )}
    </div>
    // </div>
  );
};

export default ViewableImages;
